import React, { useState } from "react";
import { completeRepair } from "../../services/api";
import { AiOutlineClose } from "react-icons/ai";
import styles from "../../styles/Repairs.module.css";

const CompleteRepairModal = ({ repairId, onClose, onRepairCompleted }) => {
    const [laborCharge, setLaborCharge] = useState("");

    const handleCompleteRepair = async () => {
        if (!laborCharge) {
            alert("Please enter labor charge.");
            return;
        }

        if (!repairId || typeof repairId !== "number") {
            console.error("Error: repairId is invalid", repairId);
            alert("Error: Repair ID is invalid!");
            return;
        }

        try {
            await completeRepair(repairId, laborCharge);
            alert("Repair completed successfully!"); // ✅ Show success message
            onRepairCompleted(); // ✅ Refresh repair data
        } catch (error) {
            alert("Error completing repair");
            console.error(error);
        }
    };



    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <div className={styles.modalHeader}>
                    <h3>Complete Repair</h3>
                    <button onClick={onClose} className={styles.closeButton}>
                        <AiOutlineClose />
                    </button>
                </div>
                <input
                    type="number"
                    placeholder="Enter Labor Charge"
                    value={laborCharge}
                    onChange={(e) => setLaborCharge(e.target.value)}
                    className={styles.inputField}
                />
                <div className={styles.buttonGroup}>
                    <button onClick={handleCompleteRepair} className={styles.button}>Complete Repair</button>
                    <button onClick={onClose} className={styles.closeButton}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default CompleteRepairModal;
